<template>
  <div class="planning-game">
    <div class="header">
      <p class="title">
        Préparer le planning des semaines à venir
      </p>
      <p class="sub-title">
        Arbitrer entre plusieurs plannings possibles
      </p>
    </div>
    <div class="plannings-menu">
      <p class="title">
        Jugez la cohérence de chacun de ces plannings
      </p>
      <div class="plannings">
        <button v-for="planning in plannings"
          :key="planning.name"
          @click="navigateTo(planning.name)"
          class="planning-button"
          :class="{ answered: planning.answer !== '' }"
        >
          <span class="label">
            Planning n°{{ planning.label }}
          </span>
          <span class="answer" :class="{ good: planning.answer, 'not-good': planning.answer === false }">
            {{ planning.answer ? 'Bon' : 'Pas bon' }}
          </span>
        </button>
      </div>
    </div>
    <div class="context-wrapper">
      <p class="title">
        contexte
      </p>
      <p>
        <strong>Nous sommes en septembre et vous préparez le planning d’octobre</strong> (du 12 octobre au dimanche 1er novembre).
        <br>
        <strong>Votre dépôt/agence est ouverte du lundi au samedi matin.</strong>
        <br>
        Majoritairement vos collaborateurs ont des <strong>contrats de 37h/semaine avec 12 RTT.</strong>
      </p>
    </div>
    <div class="checklist-wrapper">
      <p class="title">
        Contraintes à prendre en compte
      </p>
      <checklist :hide-check="true" :enable="false"></checklist>
    </div>
    <div class="button-wrapper">
      <button class="button" v-if="!isAllPlanningAnswered" @click="navigateToNextPlanning">Consulter le planning n°{{ nextPlanning.label }}</button>
      <button class="button" v-else @click="navigateTo('planningOutro')">Valider mes choix</button>
    </div>
  </div>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import { mapState, mapGetters } from 'vuex'
import Checklist from '../components/Checklist'

export default {
  name: 'PlanningGame',
  mixins: [stepMixin],
  components: {
    Checklist
  },
  computed: {
    ...mapState(['plannings', 'planningIndex']),
    ...mapGetters(['currentPlanning']),
    nextPlanning () {
      return this.plannings.filter(planning => planning.answer === '')[0]
    },
    isAllPlanningAnswered () {
      return this.plannings.filter(planning => planning.answer === '').length === 0
    }
  },
  methods: {
    navigateToNextPlanning () {
      this.$store.dispatch('navigate', this.nextPlanning.name)
    }
  }
}
</script>

<style lang="scss">
.planning-game {
  .header {
    width: 1024px;
    margin: 0 auto;
    padding-top: 20px;
    text-align: left;
    .title {
      font-family: $secondary-font;
      font-weight: 700;
      font-size: 0.95rem;
      color: $secondary-text-color;
    }
    .sub-title {
      margin-top: 10px;
      font-size: 1.9rem;
    }
  }
  .plannings-menu {
    border-radius: $radius;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border: 1px solid $background-color;
    background-color: #fff;
    max-width: 608px;
    margin: 30px auto 8px auto;
    .title {
      font-size: 0.95rem;
      font-weight: 700;
      background-color: $primary-text-color;
      color: #fff;
      width: 100%;
      text-align: left;
      padding: 10px;
      border-radius: $radius $radius 0 0;
    }
    .plannings {
      padding: 10px 15px 30px 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      .planning-button + .planning-button {
        margin-left: 15px;
      }
      .planning-button {
        flex: 1 1 0;
        min-width: 32%;
        overflow: visible;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
        border-radius: $radius;
        background-color: #fff;
        border: 1px solid $secondary-color;
        height: 60px;
        cursor: pointer;
        position: relative;
        color: $secondary-color;
        transition: $color-transition;
        .label {
          font-weight: 700;
          text-align: center;
          font-size: 0.95rem;
        }
        .answer {
          opacity: 0;
          transition: opacity 0.3s ease-out;
          position: absolute;
          left: 50%;
          height: 30px;
          width: 120px;
          background-color: $primary-color;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: -20px;
          transform: translateX(-50%);
          background-position: left 15px center;
          background-repeat: no-repeat;
          padding-left: 15px;
          font-weight: 700;
          font-size: 0.9rem;
          &.good {
            background-image: url('../assets/good-white.svg');
          }
          &.not-good {
            background-image: url('../assets/not-good-white.svg');
          }
        }
        &.answered {
          background-color: darken($secondary-color, 10);
          border-color: darken($secondary-color, 10);
          color: #fff;
          font-weight: 700;
          .answer {
            opacity: 1;
          }
        }
        &:hover {
          background-color: $secondary-color;
          color: #fff;
        }
      }
    }
  }
  .context-wrapper {
    border-radius: $radius;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border: 1px solid $background-color;
    padding: 20px 25px;
    background-color: #fff;
    max-width: 608px;
    margin: 0 auto;
    text-align: left;
    font-size: 0.94rem;
    line-height: 1.28rem;
    font-family: $secondary-font;
    .title {
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
  }
  .checklist-wrapper {
    background-color: #fff;
    margin: 8px 25px 20px 25px;
    border-radius: $radius;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border: 1px solid $background-color;
    padding: 15px;
    text-align: left;
    .title {
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
  }
  .button-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
}
</style>
